import InsightsDashboardPool, {
  DataDuck,
  ExportDuck
} from '@aytm/app/insights/dashboard/duckness/InsightsDashboardPool'
import usePool from '@duckness/use-pool'

export const useIsLoading = () => usePool(InsightsDashboardPool, DataDuck.select.isLoading)
export const useIsFreshLoading = () => usePool(InsightsDashboardPool, DataDuck.select.isFreshLoading)
export const useIsExporting = () => usePool(InsightsDashboardPool, ExportDuck.select.isExporting)
